import axios from '../../axios'

export default {
  getReportRegionOverview: async function (regionId, from, to) {
    return axios.get('possanalysis/overview/regions/' + regionId, {
      params: {
        locationTypeId: 1,
        from: from,
        to: to
      }
    })
  },
  getReportRegionErrors: async function (regionId, from, to) {
    return axios.get('possanalysis/warningsandalarms/regions/' + regionId, {
      params: {
        from: from,
        to: to
      }
    })
  },
  getReportComplexOverview: async function (complexId, from, to) {
    return axios.get('possanalysis/overview/complexes/' + complexId, {
      params: {
        locationTypeId: 1,
        from: from,
        to: to
      }
    })
  },
  getReportComplexErrors: async function (complexId, from, to) {
    return axios.get('possanalysis/warningsandalarms/complexes/' + complexId, {
      params: {
        from: from,
        to: to
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/api/ReportsApi.js